import React from 'react';
import PropTypes from 'prop-types';
import classname from 'classnames';

import themeable from 'zignal-landscape/lib/themeable';

const Badge = ({ styles, unreadCount, isNewNav }) => {
  if(unreadCount === 0){
    return null;
  }
  const badgeClassNames = {
    [styles.badge]: true,
    [styles.newBadge] :isNewNav,
    [styles.lowCount]: isNewNav && unreadCount < 10,
  };
  return (
    <span className={classname(badgeClassNames)}>{unreadCount}</span>
  );
};

Badge.propTypes = {
  styles: PropTypes.object,
  unreadCount: PropTypes.number
};

Badge.displayName = 'Badge';

export default themeable(Badge);
